import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-check-plan-action",
  // imports: [],
  templateUrl: "./check-plan-action.component.html",
  styleUrl: "./check-plan-action.component.css",
  standalone: false,
})
export class CheckPlanActionComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
